module.exports = __webpack_public_path__ + "img/Picture22.cfaf40aa.png";